export default __webpack_public_path__ + "static/media/pig.c50980e9.svg";